import { jsPDF } from 'jspdf';
import axios from 'axios';
import config from '../config/config';
const pdfConfig = config.pdf;

export async function generateCertificatePage1(data) {
  const doc = createPDFDocument();
  const page1 = pdfConfig.certificatePage1;

  const dateFont = await loadFont(doc, pdfConfig.dateFont);
  const nameFont = await loadFont(doc, pdfConfig.nameFont);

  // page 1
  doc.addImage(data.image1, 'PNG', 0, 0, pdfConfig.landscape[0], pdfConfig.landscape[1]);
  doc.setTextColor(pdfConfig.defaultTextColor);
  doc.setFont(dateFont.name, dateFont.style);
  doc.setFontSize(dateFont.size);
  const dateLocation = page1.dateLocationFn(doc.getTextWidth(data.completionDate));
  doc.text(data.completionDate, dateLocation[0], dateLocation[1]);
  doc.setFont(nameFont.name, nameFont.style);
  doc.setFontSize(nameFont.size);
  const nameLocation = page1.nameLocationFn(doc.getTextWidth(data.name));
  doc.text(data.name, nameLocation[0], nameLocation[1]);

  // page 2
  doc.addPage();
  doc.addImage(data.image2, 'PNG', 0, 0, pdfConfig.landscape[0], pdfConfig.landscape[1]);
  // download to the user's computer
  doc.save(`${data.fileName}.pdf`);
}

export async function getImageData(imageUrl) {
  try {
    const req = axios.create({
      withCredentials: false
    });
    const resp = await req.get(imageUrl, { responseType: 'arraybuffer'});
    return arrayBufferToBase64(resp.data); 
    // return Buffer.from(resp.data, 'binary').toString('base64');
  } catch(error) {
    throw error;
  }
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
}

export async function getFontData(fontUrl) {
  const req = axios.create({
    withCredentials: false
  });
  const resp = await req.get(fontUrl, { responseType: 'arraybuffer' });
  return arrayBufferToBase64(resp.data); 
}

async function loadFont(doc, font) {
  try {
    const fontData = await getFontData(font.url);
    doc.addFileToVFS(font.file, fontData);
    doc.addFont(font.file, font.name, 'normal');
    return { 
      name: font.name, 
      style: 'normal',
      size: font.size 
    };
  } catch(error) {
    console.warn('Font failed to load, using default font.');
    return { 
      name: font.fallbackFont, 
      style: font.fallbackStyle || 'normal',
      size: font.fallbackSize 
    }
  }
}

export function formatLongDate(date) {
  const [month, day, year] = date.split('/');
  return `${config.monthNames[Number(month) - 1]} ${Number(day)}, ${Number(year)}`;
}

function createPDFDocument() {
  return new jsPDF({
    orientation: "landscape",
    unit: "in",
    format: pdfConfig.landscape
  });
}